import React from 'react';

import { SkeletonSimple } from '~components/skeleton';

const AccountSkeleton = () => {
  return (
    <>
      <div className="c-account__column">
        <SkeletonSimple
          theme="primary"
          className="c-skeleton-simple__item c-skeleton-simple__account c-skeleton-simple__account--personal"
        />
        <SkeletonSimple
          theme="primary"
          className="c-skeleton-simple__item c-skeleton-simple__account c-skeleton-simple__account--actions"
        />
      </div>
      <div className="c-account__column">
        <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-skeleton-simple__account c-skeleton-simple__account--offer" />
      </div>
    </>
  );
};

export default AccountSkeleton;
